import { Autocomplete, Button, Stack, TextField } from "@mui/material";
import {
  DataGrid,
  GridActionsCellItem,
  GridColumns,
  GridRowId,
} from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { FaTrash } from "react-icons/fa";
import { useSearchParams } from "react-router-dom";
import { useUser } from "../../../../auth/UseUser";
import {
  deleteNatMeasureStructure,
  getNatGroupStructure,
  getNationalGroupSet,
  getNationalGroupSetByLevel,
  insertNatGroupStructure,
} from "../../../../server/server";
import { notif } from "../../../utils/util";

function NPIStruct({ setAvalible, avalible, disabled }: any) {
  const { user } = useUser();
  const [searchParams] = useSearchParams();
  const [group, setGroup] = useState<any>(null);
  const [subGroup, setSubGroup] = useState<any>(null);
  const [subSubGroup, setSubSubGroup] = useState<any>(null);
  const [items, setItems] = useState<any>([]);
  const [selGroup, setSelGroup] = useState<any>(null);
  const [selSubGroup, setSelSubGroup] = useState<any>(null);
  const [selSubSubGroup, setSelSubSubGroup] = useState<any>(null);
  // const [levelOneGroups, setLevelOneGroups] = useState<
  //   { id: number; name: string }[]
  // >([
  //   { id: 1, name: "Кластер 1 - Основе" },
  //   { id: 2, name: "Кластер 2 - Унутрашње тржиште" },
  //   { id: 3, name: "Кластер 3 - Конкурентност и инклузивни раст" },
  //   { id: 4, name: "Кластер 4 - Зелена агенда и одржива повезаност" },
  //   { id: 5, name: "Кластер 5 - Ресурси, пољопривреда и кохезија" },
  //   { id: 6, name: "Кластер 6 - Спољни односи" },
  // ]);

  const [editId, setEditId] = useState("");
  const loadGroups = async () => {
    //Ako se predomisle vratiti 2 na 1, i promeniti izvor podataka u autocomplete sa levelOneGroups na group
    const resp = await getNationalGroupSetByLevel(28, 1);
    if (resp?.status === 200) {
      setGroup(resp?.data);
    }
  };

  const loadSubGroups = async () => {
    // Isto ako se predomisle, vratiti zakomentarisano umesto resp
    const resp = await getNationalGroupSet(selGroup?.groupNo ?? 0);
    // const resp = await getNationalGroupSetByLevel(28, 2);
    if (resp?.status === 200) {
      setSubGroup(resp?.data);
    }
  };
  const loadSubSubGroups = async () => {
    const resp = await getNationalGroupSet(selSubGroup?.groupNo ?? 0);
    if (resp?.status === 200) {
      setSubSubGroup(resp?.data);
    }
  };

  const loadStructureById = async (id: string) => {
    const resp = await getNatGroupStructure(id, 28);

    if (resp?.status === 200) {
      setItems(resp?.data);
    }
  };

  useEffect(() => {
    loadSubGroups();
  }, [selGroup]);

  useEffect(() => {
    loadSubSubGroups();
  }, [selSubGroup]);

  useEffect(() => {
    loadGroups();
    let eId = searchParams.get("id");
    if (eId) {
      loadStructureById(eId);
      setEditId(eId);
    }
  }, []);

  const handleInstChange = (e: any, prm: any) => {
    setSelGroup(prm as any);
    setSelSubGroup(null);
    setSelSubSubGroup(null);
  };
  const subChange = (e: any, prm: any) => {
    setSelSubGroup(prm as any);
    setSelSubSubGroup(null);
  };
  const subSubChange = (e: any, prm: any) => {
    setSelSubSubGroup(prm as any);
  };
  const deleteItem = React.useCallback(
    (id: GridRowId) => () => {
      deleteStructure(id);
      setTimeout(() => {
        setItems((prevRows: any) =>
          prevRows.filter((row: any) => row.id !== id),
        );
      });
    },
    [],
  );
  const getGroupNo = () => {
    if (selSubSubGroup) {
      return selSubSubGroup.groupNo;
    }
    if (selSubGroup) {
      return selSubGroup.groupNo;
    }
    if (selGroup) {
      return selGroup.groupNo;
    }
  };

  const checkAdmin = () => {
    return !user?.roleView?.features?.includes("administration");
  };

  const deleteStructure = async (id: any) => {
    const resp = await deleteNatMeasureStructure(id);

    if (resp.status === 200) {
      loadStructureById(editId);
      notif("НПАА структура обрисана", "success");
      setSelGroup(null);
      setSelSubGroup(null);
      setSelSubSubGroup(null);
    } else {
      notif("НПАА структура није обрисана", "error");
    }
  };
  const insertStructure = async () => {
    const resp = await insertNatGroupStructure({
      natMeasure: parseInt(editId),
      group: getGroupNo(),
    });

    if (resp.status === 201) {
      loadStructureById(editId);
      notif("НПАА структура додата", "success");
      setSelGroup(null);
      setSelSubGroup(null);
      setSelSubSubGroup(null);
      setAvalible({
        ...avalible,
        1: true,
      });
    } else {
      notif("НПАА структура није додата", "error");
    }
  };

  const columns = React.useMemo<GridColumns<any>>(
    () => [
      {
        field: "name",
        headerName: "Назив NPAA поглавља",
        flex: 1,
      },
      {
        field: "username",
        headerName: "Корисник",
        maxWidth: 180,
        minWidth: 180,
        flex: 1,
      },
      {
        field: "actions",
        type: "actions",
        width: 60,
        getActions: (params) => [
          <GridActionsCellItem
            icon={<FaTrash style={{ width: 20, height: 20 }} />}
            sx={{ width: 50, height: 50 }}
            label="Обриши"
            onClick={deleteItem(params.id)}
            disabled={disabled || checkAdmin()}
          />,
        ],
      },
    ],
    [deleteItem],
  );
  return (
    <div className="flex flex-col gap-3 mt-3">
      <div className="flex items-center gap-3">
        <div className="flex flex-col items-start gap-3">
          <p className="w-[260px]">NPAA кластер</p>
          <div className="flex flex-col">
            <Autocomplete
              disabled={disabled}
              renderOption={(props, option) => {
                return (
                  <li {...props} key={option.id}>
                    {option.name}
                  </li>
                );
              }}
              value={selGroup}
              size="small"
              onChange={(event: any, newValue: any) =>
                handleInstChange(event, newValue)
              }
              id="controllable-states-demo"
              options={group}
              getOptionLabel={(option) => option?.name}
              sx={{ width: 340 }}
              renderInput={(params) => (
                <TextField {...params} label="Кластер" />
              )}
            />
          </div>
        </div>
        <div className="flex  flex-col items-start gap-3">
          <p className="w-[260px]">NPAA поглавље</p>
          <div className="flex flex-col">
            <Autocomplete
              disabled={!selGroup || disabled}
              renderOption={(props, option) => {
                return (
                  <li {...props} key={option.id}>
                    {option.name}
                  </li>
                );
              }}
              value={selSubGroup}
              noOptionsText={"Не постоји поглавље"}
              size="small"
              onChange={(event: any, newValue: any) =>
                subChange(event, newValue)
              }
              id="controllable-states-demo"
              options={subGroup}
              getOptionLabel={(option) => option?.name}
              filterOptions={(options, state) => {
                return options.filter((option) =>
                  option.name
                    .toLowerCase()
                    .includes(state.inputValue.toLowerCase()),
                );
              }}
              sx={{ width: 340 }}
              renderInput={(params) => (
                <TextField {...params} label="Поглавље" />
              )}
            />
          </div>
        </div>
        <div className="flex flex-col items-start gap-3">
          <p className="w-[260px]">NPAA под-поглавље</p>
          <div className="flex flex-col">
            <Autocomplete
              disabled={!selSubGroup || disabled}
              renderOption={(props, option) => {
                return (
                  <li {...props} key={option.id}>
                    {option.name}
                  </li>
                );
              }}
              value={selSubSubGroup}
              size="small"
              onChange={(event: any, newValue: any) =>
                subSubChange(event, newValue)
              }
              id="controllable-states-demo"
              noOptionsText={"Не постоји под-поглавље"}
              options={subSubGroup}
              getOptionLabel={(option) => option?.name}
              sx={{ width: 340 }}
              renderInput={(params) => (
                <TextField {...params} label="Под-поглавље" />
              )}
            />
          </div>
        </div>
      </div>

      <div className="w-full flex justify-end pr-4 items-center">
        <Button
          disabled={disabled || (!selGroup && !selSubGroup && !selSubSubGroup)}
          variant="contained"
          sx={{ backgroundColor: "#0F2765" }}
          onClick={insertStructure}
        >
          Потврди
        </Button>
      </div>
      {items?.length > 0 && (
        <div>
          <div className="text-[#04438b]">Положај у оквиру NPAA структуре</div>
          <div className="mt-5 h-[430px] w-full">
            <DataGrid
              rows={items}
              disableColumnMenu
              columns={columns}
              style={{ zIndex: 0 }}
              rowsPerPageOptions={[5]}
              disableSelectionOnClick
              components={{
                NoRowsOverlay: () => (
                  <Stack
                    height="100%"
                    alignItems="center"
                    justifyContent="center"
                  >
                    Не постоје NPAA поглавља
                  </Stack>
                ),
                NoResultsOverlay: () => (
                  <Stack
                    height="100%"
                    alignItems="center"
                    justifyContent="center"
                  >
                    Не постоје NPAA поглавља
                  </Stack>
                ),
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default NPIStruct;
